export const profileReducer = (state = false, action) => {
  switch (action.type) {
    case 'PROFILE':
      return action
    default:
      return state
  }
}
